<template>
    <v-container fluid>
        <v-card class="quotes-table-card">
            <div class="card-section-header px-6 py-4">
                <div class="d-flex align-center flex-wrap" style="gap:16px;">
                    <v-text-field v-model="search" outlined dense hide-details
                        placeholder="Search quotes, leads, or emails..." prepend-inner-icon="mdi-magnify" clearable
                        style="width: 300px;" class="filter-select"></v-text-field>
                    <div class="filter-button-group">
                        <span class="filter-label">Booking:</span>
                        <v-btn small :class="filter_booked === 'all' ? 'filter-btn-active' : 'filter-btn'"
                            @click="filter_booked = 'all'">All</v-btn>
                        <v-btn small :class="filter_booked === 'booked' ? 'filter-btn-active' : 'filter-btn'"
                            @click="filter_booked = 'booked'">Booked</v-btn>
                        <v-btn small :class="filter_booked === 'unbooked' ? 'filter-btn-active' : 'filter-btn'"
                            @click="filter_booked = 'unbooked'">Unbooked</v-btn>
                    </div>
                    <div class="filter-button-group">
                        <span class="filter-label">Send Status:</span>
                        <v-btn small :class="filter_sent === 'all' ? 'filter-btn-active' : 'filter-btn'"
                            @click="filter_sent = 'all'">All</v-btn>
                        <v-btn small :class="filter_sent === 'sent' ? 'filter-btn-active' : 'filter-btn'"
                            @click="filter_sent = 'sent'">Sent</v-btn>
                        <v-btn small :class="filter_sent === 'unsent' ? 'filter-btn-active' : 'filter-btn'"
                            @click="filter_sent = 'unsent'">Unsent</v-btn>
                    </div>
                    <div class="filter-button-group">
                        <span class="filter-label">Paid:</span>
                        <v-btn small :class="filter_paid === 'all' ? 'filter-btn-active' : 'filter-btn'"
                            @click="filter_paid = 'all'">All</v-btn>
                        <v-btn small :class="filter_paid === 'paid' ? 'filter-btn-active' : 'filter-btn'"
                            @click="filter_paid = 'paid'">Paid</v-btn>
                        <v-btn small :class="filter_paid === 'unpaid' ? 'filter-btn-active' : 'filter-btn'"
                            @click="filter_paid = 'unpaid'">Unpaid</v-btn>
                    </div>
                </div>
            </div>
            <v-card-text>
                <v-data-table :headers="quote_headers" :items="quotes" :sort-by.sync="sort_by"
                    :sort-desc.sync="sort_desc" :loading="loading" hide-default-footer disable-pagination>
                    <template v-slot:item="{ item }">
                        <tr>
                            <td class="py-3">
                                <a :href="`${app_url}leads/${item.lead.id}/editleads`" target="_blank"
                                    class="lead-link">
                                    <div class="lead-name">{{ item.lead.first_name }} {{ item.lead.last_name }}
                                    </div>
                                    <div class="lead-contact">{{ item.lead.email }}</div>
                                    <!-- <div class="lead-contact" v-if="item.lead.phone">{{ item.lead.phone }}</div> -->
                                </a>
                                <v-chip x-small label v-if="item.lead?.event_type?.name"
                                    :color="item.lead.event_type.name === 'Hen' ? 'pink lighten-4' : item.lead.event_type.name === 'Birthday' ? 'green lighten-4' : item.lead.event_type.name === 'Party' ? 'orange lighten-4' : 'blue lighten-4'"
                                    :text-color="item.lead.event_type.name === 'Hen' ? 'pink darken-3' : item.lead.event_type.name === 'Birthday' ? 'green darken-3' : item.lead.event_type.name === 'Party' ? 'orange darken-3' : 'blue darken-3'">{{
                                        item.lead.event_type.name
                                    }} <label v-if="item.lead.event_type.name !== 'Party'"
                                        style="white-space:preserve;">
                                        Party</label>
                                </v-chip>
                                <span v-else class="grey--text">—</span>
                            </td>
                            <td style="text-align: center;">
                                <v-icon v-if="hasOrganiserDepositPayment(item)" color="success"
                                    @click.stop="openPaymentDetailsDialog(item)" style="cursor: pointer;"
                                    title="View payment details">
                                    mdi-check-circle
                                </v-icon>
                            </td>
                            <td @click="viewCustomQuote(item)">{{ item.name }}</td>
                            <td @click="viewCustomQuote(item)">
                                <label v-if="item.total">{{ get_selected_company.currency }}{{
                                    item.total.toFixed(2) }}</label>
                            </td>
                            <td @click="viewCustomQuote(item)">
                                <label v-if="item.groupsize">{{ item.groupsize }}</label>
                            </td>
                            <td @click="viewCustomQuote(item)">
                                <v-chip color="success" v-if="item.date_sent">
                                    {{ $date(item.date_sent).format('DD/MM/YYYY') }}
                                </v-chip>
                                <v-chip color="error" v-else>Never</v-chip>
                            </td>
                            <td @click="viewCustomQuote(item)">
                                <label>{{ $date(item.created_at).format('DD/MM/YYYY') }}</label>
                                <br>
                                <label style="color:#3886A7;">{{ $date(item.created_at).format('h:m A')
                                }}</label>
                            </td>
                            <td>
                                <div style="display:flex;align-items:center;">
                                    <v-btn small depressed dark color="#3988AA" class="mr-2 leads-action-btn"
                                        @click="openCreateEventDialog(item)" v-if="!item.is_booked">
                                        <v-icon small left>mdi-bookmark-outline</v-icon>Book
                                    </v-btn>
                                    <v-btn small depressed dark color="#7C7C7C" class="mr-2 leads-action-btn"
                                        @click="unbookQuote(item)" v-else>
                                        <v-icon small left>mdi-bookmark-remove-outline</v-icon>Unbook
                                    </v-btn>
                                    <v-menu right bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn small dense icon v-bind="attrs" v-on="on">
                                                <v-icon color="black">mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item style="cursor:pointer;" @click="viewCustomQuote(item)">
                                                <v-list-item-title>
                                                    <v-icon>mdi-magnify</v-icon>View/Update Quote
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item style="cursor:pointer;" @click="openPreviewQuoteDialog(item)">
                                                <v-list-item-title>
                                                    <v-icon>mdi-navigation-variant-outline</v-icon>Send Quote
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item style="cursor:pointer;" @click="copyQuote(item)">
                                                <v-list-item-title>
                                                    <v-icon>mdi-content-copy</v-icon>Copy Quote
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item style="cursor:pointer;" @click="deleteQuoteDialog(item)">
                                                <v-list-item-title>
                                                    <v-icon>mdi-delete</v-icon>Delete Quote
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <div class="sticky-pagination" v-if="page_count > 1">
            <v-pagination v-model="page" :length="page_count" :total-visible="7"></v-pagination>
        </div>

        <CopyQuoteDialog v-model="copy_quote_dialog" :quote_id="copy_quote ? copy_quote.id : null"
            :lead_id="copy_quote ? copy_quote.lead_id : null"
            :event_id="copy_quote && copy_quote.event_id ? copy_quote.event_id : null" @copied="fetchQuotes()" />
        <ConfirmDeleteQuote :delete_quote_dialog="delete_quote_dialog" :quote_id="delete_quote_id"
            @closeDeleteQuoteDialog="closeDeleteQuoteDialog()" @deleteQuote="deleteQuote()"></ConfirmDeleteQuote>
        <CreateNewEvent v-if="create_event_dialog" :create_event_dialog="create_event_dialog" :quote="quote_for_event"
            :lead="selected_lead" @closeCreateEventDialog="closeCreateEventDialog()" @createEvent="createEvent"
            @bookQuote="bookQuote">
        </CreateNewEvent>
        <PreviewQuoteEmail :preview_dialog="preview_quote_dialog" :quote="quote_for_preview" :lead="selected_lead"
            :company="get_selected_company" @closePreviewDialog="closePreviewQuoteDialog()" @sendQuote="sendQuoteEmail"
            @sendQuoteViaSms="sendQuoteViaSms" @sendQuoteViaWhatsApp="sendQuoteViaWhatsApp">
        </PreviewQuoteEmail>
        <v-dialog v-model="payment_details_dialog" max-width="600px">
            <v-card>
                <v-card-title class="text-h5 primary white--text">
                    <v-icon left color="white">mdi-cash-check</v-icon>
                    Payment Details
                </v-card-title>
                <v-card-text class="pt-4" v-if="selected_payment">
                    <v-row>
                        <v-col cols="12">
                            <v-list>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Quote Name</v-list-item-subtitle>
                                        <v-list-item-title class="text-h6">{{ selected_payment.quote_name
                                            }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Total Paid Amount</v-list-item-subtitle>
                                        <v-list-item-title class="text-h6">{{ get_selected_company.currency }}{{
                                            selected_payment.total_paid_amount.toFixed(2) }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Payment Date</v-list-item-subtitle>
                                        <v-list-item-title>{{ $date(selected_payment.payment_date).format('DD/MM/YYYY')
                                            }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Payment Gateway</v-list-item-subtitle>
                                        <v-list-item-title>{{ selected_payment.payment_gateway }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item v-if="selected_payment.reference_code">
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Reference Code</v-list-item-subtitle>
                                        <v-list-item-title>{{ selected_payment.reference_code }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="payment_details_dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <SupplierChangesPrompt :changes="supplier_changes" @close="supplier_changes = null" />
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import SupplierChangesPrompt from '../events/components/SupplierChangesPrompt.vue'
import ConfirmDeleteQuote from '../leads/components/ConfirmDeleteQuote.vue'
import CopyQuoteDialog from './components/CopyQuoteDialog.vue'
import CreateNewEvent from '../events/components/CreateNewEvent.vue'
import PreviewQuoteEmail from '../leads/components/PreviewQuoteEmail.vue'
import pageBadgesMixin from '@/common/PageNameStore/pageBadgesMixin'

export default {
    mixins: [pageBadgesMixin],
    components: {
        ConfirmDeleteQuote, CreateNewEvent, PreviewQuoteEmail, CopyQuoteDialog, SupplierChangesPrompt
    },
    data: () => ({
        // From the API after deleting a quote: booked suppliers to offer a cancellation email.
        supplier_changes: null,
        quote_headers: [
            { text: 'Lead Name', value: 'lead.first_name', width: '200px', sortable: false },
            { text: 'Paid', value: 'paid', width: '60px', sortable: false, align: 'center' },
            { text: 'Quote Name', value: 'name' },
            { text: 'Total', value: 'total' },
            { text: 'Groupsize', value: 'groupsize' },
            { text: 'Date Sent', value: 'date_sent' },
            { text: 'Created', value: 'created_at', width: '120px' },
            { text: 'Action', value: 'action', width: '100', align: 'center' },
        ],
        quotes: [],
        loading: false,
        sort_by: 'created_at',
        sort_desc: true,
        page: 1,
        page_count: 0,
        items_per_page: 25,
        total_quotes: 0,
        search: '',
        search_timeout: null,
        delete_quote_id: null,
        delete_quote_dialog: false,
        copy_quote_dialog: false,
        copy_quote: null,
        create_event_dialog: false,
        quote_for_event: null,
        selected_lead: null,
        preview_quote_dialog: false,
        quote_for_preview: null,
        payment_details_dialog: false,
        selected_payment: null,
        filter_booked: 'all',
        filter_sent: 'all',
        filter_paid: 'all',
    }),
    computed: {
        app_url() {
            return process.env.VUE_APP_URL
        },
        pageBadges() {
            return [this.total_quotes.toLocaleString()]
        },
        ...mapGetters({
            get_selected_company: 'auth/get_selected_company',
        })
    },
    async mounted() {
        this.setPageName("Quotes")
        this.fetchQuotes()
    },
    watch: {
        page() {
            this.fetchQuotes()
        },
        filter_booked() {
            this.page = 1
            this.fetchQuotes()
        },
        filter_sent() {
            this.page = 1
            this.fetchQuotes()
        },
        filter_paid() {
            this.page = 1
            this.fetchQuotes()
        },
        search() {
            clearTimeout(this.search_timeout)
            this.search_timeout = setTimeout(() => {
                this.page = 1
                this.fetchQuotes()
            }, 500)
        }
    },
    methods: {
        setPageName(name) {
            this.$store.dispatch('pageNameStore/setPageNameAction', name)
        },
        async fetchQuotes() {
            this.loading = true
            try {
                const response = await this.$axios.get(`admin/quotes/get_quotes_by_company/${this.get_selected_company.id}?page=${this.page}&per_page=${this.items_per_page}&filter_booked=${this.filter_booked}&filter_sent=${this.filter_sent}&filter_paid=${this.filter_paid}&search=${encodeURIComponent(this.search || '')}`)
                if (response.data.response) {
                    this.quotes = response.data.data
                    this.total_quotes = response.data.total
                    this.page_count = response.data.last_page
                }
            } catch (error) {
                console.error('Error fetching quotes:', error)
            } finally {
                this.loading = false
            }
        },
        viewCustomQuote(quote) {
            this.$router.push({ name: 'EditCustomQuote', params: { lead_id: quote.lead_id, quote_id: quote.id } })
        },
        hasOrganiserDepositPayment(quote) {
            return quote.payments && quote.payments.length > 0
        },
        openPaymentDetailsDialog(quote) {
            if (quote.payments && quote.payments.length > 0) {
                const payment = quote.payments[0]
                let reference_code = ''
                try {
                    const payment_collection = JSON.parse(payment.payment_collection)
                    reference_code = payment_collection.reference_code || ''
                } catch (e) {
                    // ignore
                }
                this.selected_payment = {
                    quote_name: quote.name,
                    total_paid_amount: payment.total_paid_amount,
                    payment_date: payment.payment_date,
                    payment_gateway: payment.payment_gateway,
                    reference_code: reference_code
                }
                this.payment_details_dialog = true
            }
        },
        openCreateEventDialog(quote) {
            this.quote_for_event = quote
            this.selected_lead = quote.lead
            this.create_event_dialog = true
        },
        closeCreateEventDialog() {
            this.create_event_dialog = false
        },
        async createEvent(event_data) {
            try {
                const response = await this.$axios.post('admin/events/create_event', event_data)
                if (response.data.response) {
                    this.$toast.success('Event created successfully')
                    this.closeCreateEventDialog()
                    await this.fetchQuotes()
                }
            } catch (error) {
                this.$toast.error('Failed to create event')
                console.error(error)
            }
        },
        async bookQuote(quote_id) {
            try {
                const response = await this.$axios.post('admin/quotes/book_quote', { quote_id })
                if (response.data.response) {
                    this.$toast.success('Quote booked successfully')
                    await this.fetchQuotes()
                }
            } catch (error) {
                this.$toast.error('Failed to book quote')
                console.error(error)
            }
        },
        async unbookQuote(quote) {
            try {
                const response = await this.$axios.post('admin/quotes/unbook_quote', { quote_id: quote.id })
                if (response.data.response) {
                    this.$toast.success('Quote unbooked successfully')
                    await this.fetchQuotes()
                }
            } catch (error) {
                this.$toast.error('Failed to unbook quote')
                console.error(error)
            }
        },
        openPreviewQuoteDialog(quote) {
            this.quote_for_preview = quote
            this.selected_lead = quote.lead
            this.preview_quote_dialog = true
        },
        closePreviewQuoteDialog() {
            this.preview_quote_dialog = false
        },
        async sendQuoteEmail(options) {
            try {
                const payload = {
                    company_id: this.get_selected_company.id,
                    lead: this.selected_lead,
                    quote: this.quote_for_preview,
                    show_description: options.show_descriptions,
                    show_names: options.show_names,
                }
                const response = await this.$axios.post('admin/quotes/send_email_quote', payload)
                if (response.data.response) {
                    this.$toast.success('Quote sent successfully')
                    this.closePreviewQuoteDialog()
                    await this.fetchQuotes()
                }
            } catch (error) {
                this.$toast.error('Failed to send quote')
                console.error(error)
            }
        },
        async sendQuoteViaSms() {
            try {
                const payload = {
                    company_id: this.get_selected_company.id,
                    lead: this.selected_lead,
                    quote: this.quote_for_preview,
                }
                const response = await this.$axios.post('admin/quotes/send_sms_quote', payload)
                if (response.data.response) {
                    this.$toast.success('Quote sent via SMS successfully')
                    this.closePreviewQuoteDialog()
                    await this.fetchQuotes()
                }
            } catch (error) {
                this.$toast.error('Failed to send quote via SMS')
                console.error(error)
            }
        },
        async sendQuoteViaWhatsApp() {
            try {
                const payload = {
                    company_id: this.get_selected_company.id,
                    lead: this.selected_lead,
                    quote: this.quote_for_preview,
                }
                const response = await this.$axios.post('admin/quotes/send_whatsapp_quote', payload)
                if (response.data.response) {
                    this.$toast.success('Quote sent via WhatsApp successfully')
                    this.closePreviewQuoteDialog()
                    await this.fetchQuotes()
                }
            } catch (error) {
                this.$toast.error('Failed to send quote via WhatsApp')
                console.error(error)
            }
        },
        copyQuote(quote) {
            this.copy_quote = quote
            this.copy_quote_dialog = true
        },
        deleteQuoteDialog(quote) {
            this.delete_quote_id = quote.id
            this.selected_lead = quote.lead
            this.delete_quote_dialog = true
        },
        closeDeleteQuoteDialog() {
            this.delete_quote_dialog = false
        },
        async deleteQuote() {
            try {
                const response = await this.$axios.delete(`admin/quotes/delete_quote_with_builds/${this.delete_quote_id}/${this.get_selected_company.id}/${this.selected_lead.id}`)
                if (response.data.response) {
                    this.$toast.success('Quote deleted successfully')
                    this.closeDeleteQuoteDialog()
                    this.supplier_changes = response.data.supplier_changes || null
                    await this.fetchQuotes()
                }
            } catch (error) {
                // e.g. the API refuses to delete a quote that has payments against it
                this.$toast.error(error.response?.data?.message || 'Failed to delete quote')
                console.error(error)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.sticky-pagination {
    position: fixed;
    bottom: 20px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    z-index: 100;
    pointer-events: none;

    ::v-deep .v-pagination {
        pointer-events: all;
        background: white;
        border-radius: 8px;
        padding: 4px 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    }
}

.card-section-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
}

.card-section-title {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 700;
    color: white;
}

.filter-select {
    background: rgba(255, 255, 255, 0.2);
}

.filter-select ::v-deep .v-input__control {
    background: white;
    border-radius: 4px;
}

.leads-action-btn {
    font-family: Manrope;
    font-size: 12px;
    font-weight: 600;
    text-transform: none;
}

.lead-link {
    text-decoration: none;
    color: inherit;
}

.lead-link .lead-name {
    color: #3988AA;
    text-decoration: underline;
}

.lead-name {
    font-family: Manrope;
    font-weight: 600;
    font-size: 14px;
    color: #000;
}

.lead-contact {
    font-family: Manrope;
    font-size: 12px;
    color: #7C7C7C;
    margin-top: 2px;
}

.filter-button-group {
    display: flex;
    align-items: center;
    gap: 4px;
}

.filter-label {
    font-family: Manrope;
    font-size: 12px;
    font-weight: 600;
    color: white;
    margin-right: 4px;
}

.filter-btn {
    background: rgba(255, 255, 255, 0.2) !important;
    color: white !important;
    font-family: Manrope;
    font-size: 12px;
    font-weight: 500;
    text-transform: none;
    border-radius: 4px;
    min-width: 70px;
}

.filter-btn-active {
    background: white !important;
    color: #3988AA !important;
    font-family: Manrope;
    font-size: 12px;
    font-weight: 600;
    text-transform: none;
    border-radius: 4px;
    min-width: 70px;
}

.quotes-table-card {
    border-radius: 10px !important;
    border: 1px solid #E9E9E9 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
    overflow: hidden;
    margin-bottom:100px;
}
</style>
